/**
 * @file   url.js 处理url相关的一些工具方法
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2021-01-07
 * @doc    https://console.cloud.baidu-int.com/devops/icode/repos/baidu/exp-fe/utils/blob/master:src/url.js
 */
import {url} from '@baidu/exp-utils';

export function getUrlParam() {
    return url.parse().params;
}

export function isBaiduHost() {
    let arr = url.parse().hostname.split('.');
    let len = arr.length;
    return arr[len - 1] === 'com' && arr[len - 2] === 'baidu';
}

export default url;
